import { Integrations } from "@/features/settings/integrations";

export const Route = createFileRoute({
  component: Integrations,
});
